module.exports = __webpack_public_path__ + "static/media/sup_tropical_640.5f99d1ee.jpg";